import React from 'react';
import Masonry from 'react-masonry-component';
import { visitAnalyticEvent } from '../../../pages/EventReg/analyticsNew';

class CourseContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: props.content,
    };
  }

  componentDidUpdate(prevProps) {

    if (this.props.content !== prevProps.content) {
      this.setState({ content: this.props.content });
    }
  }

  prepareElements() {
    const { content } = this.state;
    visitAnalyticEvent();
    const html = content.map((item, index) => {
      if (item.children.length) {


        const children = item.children.map(child => {
          return (
            <p key={child.id}>
              <a
                href={`${child.url}?from=menu`}
                dangerouslySetInnerHTML={{ __html: child.name }}
              />
            </p>
          );
        });

        return (
          <div key={item.id} className="popup-nav__content-item">
            <h3>{item.name}</h3>
            {children}
          </div>
        );
      } else {
        return (
          <div
            key={item.id}
            className="popup-nav__content-item popup-nav__content-item--zeromargin"
          >
            <p>
              <a href={`${item.url}?from=menu`}>
                <div dangerouslySetInnerHTML={{ __html: item.name }}></div>
              </a>
            </p>
          </div>
        );
      }
    });

    if (html.length == 0) {
      html.push(
        <div key={'error'} className="popup-nav__content-item">
          <p>К сожалению, ничего не найдено</p>
        </div>,
      );
    }

    return html;
  }

  render() {
    return (
      <Masonry
        className={'popup-nav__content'}
        options={{
          columnWidth: '.popup-nav__content-sizer',
          itemSelector: '.popup-nav__content-item',
          percentPosition: true,
          transitionDuration: 0,
        }}
      >
        <div className="popup-nav__content-sizer"/>
        {this.prepareElements()}
      </Masonry>
    );
  }
}

export default CourseContent;
